import React, { useState } from "react";

const CheckBox = ({type = null, name, id, onChange}) => {

    const checkBoxPayload = { 
        type: type,
        name: name,
        id: id
    }

    return (
        <div className="filter__checkox-item">
            <input onChange={() => onChange(checkBoxPayload)} type='checkbox' name={name} value={id} />
            <label for={name}>{name}</label>
        </div>
    )
}

export default CheckBox;